// extracted by mini-css-extract-plugin
export var allEvents = "agenda-module--all-events--23597";
export var editButton = "agenda-module--edit-button--ba739";
export var editButtonTitle = "agenda-module--edit-button-title--284f3";
export var eventsCarousel = "agenda-module--events-carousel--5e952";
export var eventsCarouselArrowLeft = "agenda-module--events-carousel-arrow-left--de714";
export var eventsCarouselArrowRight = "agenda-module--events-carousel-arrow-right--a84f2";
export var eventsCarouselDotsWrapper = "agenda-module--events-carousel-dots-wrapper--60bb3";
export var eventsContainer = "agenda-module--events-container--182e8";
export var eventsDescription = "agenda-module--events-description--cc9d6";
export var eventsHeader = "agenda-module--events-header--c0875";
export var eventsIncomingDate = "agenda-module--events-incoming-date--15e77";
export var eventsIncomingLine = "agenda-module--events-incoming-line--e222c";
export var eventsItem = "agenda-module--events-item--6c15a";
export var eventsItemDate = "agenda-module--events-item-date--f6920";
export var eventsItemDateFrom = "agenda-module--events-item-date-from--2ee74";
export var eventsItemDateTo = "agenda-module--events-item-date-to--c6452";
export var eventsItemImg = "agenda-module--events-item-img--aa404";
export var eventsItemTaxo = "agenda-module--events-item-taxo--9fa7c";
export var eventsItemTaxoLine = "agenda-module--events-item-taxo-line--2a402";
export var eventsItemTitle = "agenda-module--events-item-title--63ac4";
export var listEventsContainer = "agenda-module--list-events-container--20c57";
export var listEventsTitle = "agenda-module--list-events-title--75626";
export var pauseButton = "agenda-module--pause-button--bcc6d";